import { UserProfile } from 'src/api/model/user-profile';
import { RequestBuilder } from 'src/api/common/request-builder';
// import { UserModule } from '@/store/modules/user'
// import { Pagable } from 'src/constants/pagable';
// import { RequestUtils } from 'src/utils/request-utils';
import { UserProfileForm } from 'src/api/model/form/user-profile-form';

export class UserProfileApi {
  getCurrentUser(): Promise<UserProfile> {
    return new RequestBuilder<UserProfile>()
      .url('/member/userProfile')
      .findOne();
  }

  findById(id: string): Promise<UserProfile> {
    return new RequestBuilder<UserProfile>()
      .url(`/userProfile/${id}`)
      .findOne();
  }

  // loadUserDeptRoles(form: UserDeptRole, pagable: Pagable): Promise<UserDeptRole[]> {
  //   const params = RequestUtils.merge(
  //     form,
  //     RequestUtils.initPageableParams(pagable)
  //   )
  //   return new RequestBuilder<UserDeptRole>()
  //     .url('/userDeptRoleView')
  //     .config({ params: params })
  //     .findAll()
  // }

  save(form: UserProfileForm) {
    return new RequestBuilder<UserProfile>()
      .url('/member/userProfile')
      .data(form)
      .post();
  }

  update(id: string, form: UserProfileForm) {
    return new RequestBuilder<UserProfile>()
      .url(`/userProfile/${id}`)
      .data(form)
      .put();
  }

  delete(id: string) {
    return new RequestBuilder<UserProfile>()
      .url(`/userProfile/${id}`)
      .delete();
  }
  //
  // findAllRole(form: RoleSearchForm, pagable: Pagable): Promise<Role[]> {
  //   const params = RequestUtils.merge(
  //     form,
  //     RequestUtils.initPageableParams(pagable)
  //   )
  //   return new RequestBuilder<Role>()
  //     .url('/role')
  //     .config(params)
  //     .findAll()
  // }
}

export const userProfileApi = new UserProfileApi();
